import { FunctionComponent } from 'react';

import { Field, Widget } from '@kanda-libs/ks-component-ts';

import SatNoteAddressFields from './AddressFIelds';
import {
  COMPLETE_INPUT_PROPS,
  COMPLETE_INPUT_VALIDATION,
  INPUT_PROPS,
} from './constants';

const SatNoteFormQuestionsStandard: FunctionComponent = () => (
  <>
    <Field.Validator validation={COMPLETE_INPUT_VALIDATION}>
      <Field.Select {...COMPLETE_INPUT_PROPS} />
    </Field.Validator>
    <Widget.JobSatNoteQPressure {...INPUT_PROPS} />
    <Widget.JobSatNoteQEasiness {...INPUT_PROPS} />
    <Widget.JobSatNoteQAvailability {...INPUT_PROPS} />
    <Widget.JobSatNoteQApplication {...INPUT_PROPS} />
    <Widget.JobSatNoteQAdvice {...INPUT_PROPS} />
    <Widget.JobSatNoteQRate {...INPUT_PROPS} />
    <SatNoteAddressFields />
    <Field.FingerprintBooleanInput
      handle="checkbox"
      name="acknowledged"
      fieldText="I acknowledge that by clicking the submit button I agree the job has been completed satisfactorily"
    />
  </>
);

export default SatNoteFormQuestionsStandard;
